import { useTranslation } from "react-i18next";

import { getTranslationKey, TCodelistName } from "@/data/codelists";

export const useCodelistTranslation = () => {
  const { t } = useTranslation("codelists");

  const translateCodelist = (codelistName: TCodelistName, code: string) => {
    const key = getTranslationKey(codelistName, code);
    return key ? t(key) : code;
  };

  return translateCodelist;
};
